/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_Scoring_DescInputs */

const en_directory_submit_workspace_aside_scoring_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Scoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editors review; our scripts calculate AI Readiness and GEO Score.`)
};

const zh_directory_submit_workspace_aside_scoring_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Scoring_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑审核；平台脚本计算 AI 就绪度和 GEO Score。`)
};

/**
* | output |
* | --- |
* | "Editors review; our scripts calculate AI Readiness and GEO Score." |
*
* @param {Directory_Submit_Workspace_Aside_Scoring_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_scoring_desc = /** @type {((inputs?: Directory_Submit_Workspace_Aside_Scoring_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_Scoring_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_scoring_desc(inputs)
	return zh_directory_submit_workspace_aside_scoring_desc(inputs)
});
export { directory_submit_workspace_aside_scoring_desc as "directory.submit.workspace.aside.scoring_desc" }